// // 本地
const BASE_URI = '/imgs';

// 七牛云测试环境
// const BASE_URI = 'http://pn1xuf0e5.bkt.clouddn.com/imgs';

// // 七牛云正式环境

export default {
  about_ditu: `${BASE_URI}/about/ditu.png`,
  about_ditulogo: `${BASE_URI}/about/ditulogo.png`,

  common_about_banner: `${BASE_URI}/common/about-banner.jpg`,
  common_back: `${BASE_URI}/common/back.png`,
  common_contact_banner: `${BASE_URI}/common/contact-banner.jpg`,
  common_home_news_bgimg: `${BASE_URI}/common/home-news-bgimg.jpg`,
  common_home_swiper_bgimg: `${BASE_URI}/common/home-swiper-bgimg.jpg`,
  common_logo: `${BASE_URI}/common/logo.png`,
  common_machining_banner: `${BASE_URI}/common/machining-banner.jpg`,
  common_news_banner: `${BASE_URI}/common/news-banner.jpg`,
  common_newsdetail_banner: `${BASE_URI}/common/newsdetail-banner.jpg`,
  common_productdetail_banner: `${BASE_URI}/common/productdetail-banner.jpg`,
  common_productlist_banner_bgimg:
    `${BASE_URI}/common/productlist-banner-bgimg.jpg`,
  common_qr_code: `${BASE_URI}/common/qr-code.jpg`,
  common_single_banner: `${BASE_URI}/common/single-banner.jpg`,

  customer_qq: `${BASE_URI}/customer/qq.png`,

  factory_jiagong1: `${BASE_URI}/factory/jiagong1.jpg`,
  factory_jiagong2: `${BASE_URI}/factory/jiagong2.jpg`,

  gallery_chanpin1: `${BASE_URI}/gallery/chanpin1.jpg`,
  gallery_chanpin2: `${BASE_URI}/gallery/chanpin2.jpg`,
  gallery_chanpin3: `${BASE_URI}/gallery/chanpin3.jpg`,
  gallery_chanpin4: `${BASE_URI}/gallery/chanpin4.jpg`,
  gallery_chanpin5: `${BASE_URI}/gallery/chanpin5.jpg`,
  gallery_chanpin6: `${BASE_URI}/gallery/chanpin6.jpg`,
  gallery_chanpin7: `${BASE_URI}/gallery/chanpin7.jpg`,
  gallery_chanpin8: `${BASE_URI}/gallery/chanpin8.jpg`,
  gallery_chanpin9: `${BASE_URI}/gallery/chanpin9.jpg`,
  gallery_chanpin10: `${BASE_URI}/gallery/chanpin10.jpg`,
  gallery_chanpin11: `${BASE_URI}/gallery/chanpin11.jpg`,

  swipper_banner1: `${BASE_URI}/swipper/banner1.jpg`,
  swipper_banner2: `${BASE_URI}/swipper/banner2.png`,
  swipper_banner2logo: `${BASE_URI}/swipper/banner2logo.png`,
};
